export const MAIN_VIEW = {
  RESULT: "result",
  DETAIL: "detail",
  SELECTION: "selection",
  DOSSIER: "dossier",
  PRINT_LABEL: "print-label",
  SETTINGS: "settings",
  ERROR: "error",
};
